import { DEFAULT_DOMAIN_ID } from '@/common/constants/domains.constants';
import useAuthStore from '@/common/store/pinia/auth';
import useStorageClusterStore from '@/common/store/pinia/storageCluster';

const getters = {
  currentDomainId: state => {
    const authStore = useAuthStore();
    return state.routes.params.domainId || authStore.currentUser?.domain_id || DEFAULT_DOMAIN_ID;
  },
  currentDomainIsDefault: (state, _getters) => _getters.currentDomainId === DEFAULT_DOMAIN_ID,
  cluster: () => {
    // TODO: check if it's actually used
    const storageClusterStore = useStorageClusterStore();
    return storageClusterStore.current;
  }
};

export default getters;
